// @ts-nocheck
import { mysqlTable, mysqlSchema, AnyMySqlColumn, index, foreignKey, primaryKey, unique, int, varchar, datetime, json, tinyint, check, decimal, text, bigint, timestamp, uniqueIndex } from "drizzle-orm/mysql-core"
import { sql } from "drizzle-orm"

export const anyInputDepositAddresses = mysqlTable("AnyInputDepositAddresses", {
	id: int().autoincrement().notNull(),
	quoteId: int().notNull().references(() => quotes.id, { onDelete: "cascade" } ),
	blockchain: varchar({ length: 32 }).notNull(),
	address: varchar({ length: 128 }).notNull(),
	memo: varchar({ length: 64 }),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	index("IDX__any_input_deposit_address__quoteId").on(table.quoteId),
	index("IDX__any_input_deposit_address__address_memo").on(table.address, table.memo),
	primaryKey({ columns: [table.id], name: "AnyInputDepositAddresses_id"}),
	uniqueIndex("UQ__any_input_deposit_address__address_memo_blockchain").on(table.address, sql`coalesce(${table.memo}, '')`, table.blockchain),
]);

export const anyInputQuoteWithdrawal = mysqlTable("AnyInputQuoteWithdrawal", {
	id: int().autoincrement().notNull(),
	amountOut: varchar({ length: 64 }).notNull(),
	amountOutFormatted: varchar({ length: 32 }).notNull(),
	amountOutUsd: varchar({ length: 32 }).notNull(),
	withdrawFee: varchar({ length: 64 }).notNull(),
	withdrawFeeFormatted: varchar({ length: 32 }).notNull(),
	withdrawFeeUsd: varchar({ length: 32 }).notNull(),
	timestamp: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	status: varchar({ length: 32 }).notNull(),
	destinationChainTxHash: varchar({ length: 256 }).notNull(),
	intentHash: varchar({ length: 256 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	quoteId: int().references(() => quotes.id),
	childQuoteId: int().references(() => quotes.id),
},
(table) => [
	primaryKey({ columns: [table.id], name: "AnyInputQuoteWithdrawal_id"}),
	unique("UQ__any_input_withdrawal__childQuoteId").on(table.childQuoteId),
]);

export const dynamicConfig = mysqlTable("DynamicConfig", {
	name: varchar({ length: 128 }).notNull(),
	value: json().notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	primaryKey({ columns: [table.name], name: "DynamicConfig_name"}),
]);

export const feeEvents = mysqlTable("FeeEvents", {
	id: varchar({ length: 36 }).notNull(),
	quoteId: varchar({ length: 64 }).notNull(),
	partnerId: varchar({ length: 64 }).notNull(),
	recipientAddress: varchar({ length: 512 }).notNull(),
	recipientType: varchar({ length: 16 }).default('partner').notNull(),
	feeBps: int().notNull(),
	amountAtomic: varchar({ length: 128 }).notNull(),
	tokenId: varchar({ length: 255 }).notNull(),
	txHash: varchar({ length: 128 }),
	isConfidential: tinyint().default(0).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	index("IDX__fee_event__quoteId").on(table.quoteId),
	index("IDX__fee_event__partnerId_createdAt").on(table.partnerId, table.createdAt),
	index("IDX__fee_event__partnerId_isConfidential_createdAt").on(table.partnerId, table.isConfidential, table.createdAt),
	primaryKey({ columns: [table.id], name: "FeeEvents_id"}),
	unique("UQ__fee_event__quoteId_recipient").on(table.quoteId, table.recipientAddress, table.recipientType, table.feeBps),
]);

export const fees = mysqlTable("Fees", {
	id: int().autoincrement().notNull(),
	recipient: varchar({ length: 255 }).notNull(),
	fee: int().notNull(),
	quoteId: int().references(() => quotes.id, { onDelete: "cascade" } ),
	limitOrderId: int().references(() => limitOrder.id, { onDelete: "cascade" } ),
},
(table) => [
	index("IDX__fees__quoteId").on(table.quoteId),
	index("IDX__fees__recipient_quoteId").on(table.recipient, table.quoteId),
	index("IDX__fees__quoteId_recipient").on(table.quoteId, table.recipient),
	index("IDX__fees__limitOrderId").on(table.limitOrderId),
	primaryKey({ columns: [table.id], name: "Fees_id"}),
]);

export const limitOrder = mysqlTable("LimitOrder", {
	id: int().autoincrement().notNull(),
	correlationId: varchar({ length: 255 }).notNull(),
	accountId: varchar({ length: 255 }).notNull(),
	depositAddress: varchar({ length: 255 }).notNull(),
	depositMemo: varchar({ length: 255 }),
	depositMode: varchar({ length: 255 }).default('SIMPLE').notNull(),
	depositType: varchar({ length: 255 }).notNull(),
	refundTo: varchar({ length: 512 }).notNull(),
	refundType: varchar({ length: 255 }).notNull(),
	recipient: varchar({ length: 512 }).notNull(),
	recipientType: varchar({ length: 255 }).notNull(),
	confidentiality: varchar({ length: 16 }),
	timeInForce: varchar({ length: 16 }).default('GTC').notNull(),
	phase: varchar({ length: 32 }).default('PENDING').notNull(),
	cancelRequestedAt: timestamp({ fsp: 3, mode: 'string' }),
	depositedAmountIn: decimal({ precision: 65, scale: 0 }).default('0').notNull(),
	originAsset: varchar({ length: 255 }).notNull(),
	destinationAsset: varchar({ length: 255 }).notNull(),
	amountIn: decimal({ precision: 65, scale: 0 }).notNull(),
	limitAmountOut: decimal({ precision: 65, scale: 0 }).notNull(),
	limitRate: decimal({ precision: 65, scale: 30 }).notNull(),
	deadline: timestamp({ fsp: 3, mode: 'string' }).notNull(),
	attemptCount: int().default(0).notNull(),
	partnerId: varchar({ length: 255 }),
	authorities: json(),
	lastCheckedAt: timestamp({ fsp: 3, mode: 'string' }),
	lastFailureReason: varchar({ length: 256 }),
	withdrawFee: decimal({ precision: 65, scale: 0 }).notNull(),
	refundedAmountUsd: varchar({ length: 32 }),
	refundReason: varchar({ length: 255 }),
	processWithdrawalParams: json(),
	createdAt: datetime({ mode: 'string', fsp: 3 }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	side: varchar({ length: 16 }).notNull(),
	price: varchar({ length: 128 }).notNull(),
	refundFee: decimal({ precision: 65, scale: 0 }).notNull(),
	publicId: varchar({ length: 27 }).notNull(),
	quantity: decimal({ precision: 65, scale: 0 }).notNull(),
	accountHashVersion: varchar({ length: 32 }).default('v0').notNull(),
	derivationVersion: varchar({ length: 32 }).default('v2').notNull(),
},
(table) => [
	index("IDX__limit_order__phase_market_rate").on(table.phase, table.originAsset, table.destinationAsset, table.limitRate, table.deadline, table.id),
	index("IDX__limit_order__phase_market_checked").on(table.phase, table.originAsset, table.destinationAsset, table.lastCheckedAt),
	index("IDX__limit_order__deadline_phase").on(table.deadline, table.phase),
	index("IDX__limit_order__createdAt_publicId").on(table.createdAt, table.publicId),
	primaryKey({ columns: [table.id], name: "LimitOrder_id"}),
	unique("UQ__limit_order__accountId").on(table.accountId),
	unique("UQ__limit_order__publicId").on(table.publicId),
	unique("UQ__limit_order__depositAddress_depositMemo").on(table.depositAddress, table.depositMemo),
	check("CHK__limit_order__amountIn_non_negative", sql`(\`amountIn\` >= 0)`),
	check("CHK__limit_order__depositedAmountIn_non_negative", sql`(\`depositedAmountIn\` >= 0)`),
	check("CHK__limit_order__limitAmountOut_non_negative", sql`(\`limitAmountOut\` >= 0)`),
	check("CHK__limit_order__limitRate_non_negative", sql`(\`limitRate\` >= 0)`),
	check("CHK__limit_order__quantity_non_negative", sql`(\`quantity\` >= 0)`),
	check("CHK__limit_order__refundFee_non_negative", sql`(\`refundFee\` >= 0)`),
	check("CHK__limit_order__withdrawFee_non_negative", sql`(\`withdrawFee\` >= 0)`),
]);

export const limitOrderPhaseTransition = mysqlTable("LimitOrderPhaseTransition", {
	id: int().autoincrement().notNull(),
	limitOrderId: int().notNull().references(() => limitOrder.id, { onDelete: "cascade" } ),
	fromPhase: varchar({ length: 32 }).notNull(),
	toPhase: varchar({ length: 32 }).notNull(),
	reason: varchar({ length: 256 }),
	createdAt: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
},
(table) => [
	index("IDX__limit_order_phase_transition__limitOrderId").on(table.limitOrderId),
	primaryKey({ columns: [table.id], name: "LimitOrderPhaseTransition_id"}),
]);

export const outlayerQuotes = mysqlTable("OutlayerQuotes", {
	id: int().autoincrement().notNull(),
	quoteId: int().notNull(),
	swapAccountId: varchar({ length: 64 }).notNull(),
	shieldAccountId: varchar({ length: 64 }),
	unshieldAccountId: varchar({ length: 64 }),
	withdrawId: varchar({ length: 64 }).notNull(),
	refundId: varchar({ length: 64 }).notNull(),
	appKind: varchar({ length: 32 }).notNull(),
	appId: varchar({ length: 64 }).notNull(),
	appCodeHash: varchar({ length: 64 }).notNull(),
	withdrawAppId: varchar({ length: 64 }).notNull(),
	withdrawAppCodeHash: varchar({ length: 64 }).notNull(),
	shieldAppId: varchar({ length: 64 }),
	shieldAppCodeHash: varchar({ length: 64 }),
	unshieldAppId: varchar({ length: 64 }),
	unshieldAppCodeHash: varchar({ length: 64 }),
	salt: varchar({ length: 64 }).notNull(),
	recoveryAccountId: varchar({ length: 64 }).notNull(),
	maxRefundPrefundFee: decimal({ precision: 65, scale: 0 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	primaryKey({ columns: [table.id], name: "OutlayerQuotes_id"}),
	unique("REL_90586caa60aea755f8c98558e2").on(table.quoteId),
]);

export const partialFill = mysqlTable("PartialFill", {
	id: int().autoincrement().notNull(),
	limitOrderId: int().references(() => limitOrder.id, { onDelete: "cascade" } ),
	correlationId: varchar({ length: 255 }).notNull(),
	amountIn: decimal({ precision: 65, scale: 0 }).notNull(),
	actualAmountIn: decimal({ precision: 65, scale: 0 }).notNull(),
	amountOut: decimal({ precision: 65, scale: 0 }).notNull(),
	status: varchar({ length: 32 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	quoteImprovementFee: decimal({ precision: 65, scale: 0 }),
	publicId: varchar({ length: 26 }).notNull(),
},
(table) => [
	index("IDX__limit_order_fill__limitOrderId").on(table.limitOrderId),
	primaryKey({ columns: [table.id], name: "PartialFill_id"}),
	unique("UQ__partial_fill__publicId").on(table.publicId),
	check("CHK__partial_fill__amountIn_non_negative", sql`(\`amountIn\` >= 0)`),
	check("CHK__partial_fill__actualAmountIn_non_negative", sql`(\`actualAmountIn\` >= 0)`),
	check("CHK__partial_fill__amountOut_non_negative", sql`(\`amountOut\` >= 0)`),
	check("CHK__partial_fill__quoteImprovementFee_non_negative", sql`(\`quoteImprovementFee\` >= 0)`),
]);

export const partnerPayoutConfigs = mysqlTable("PartnerPayoutConfigs", {
	id: int().autoincrement().notNull(),
	partnerId: varchar({ length: 64 }).notNull(),
	quoteId: int(),
	derivedAddress: varchar({ length: 256 }).notNull(),
	accumulationAsset: varchar({ length: 255 }).default('nep141:wrap.near').notNull(),
	payoutChain: varchar({ length: 32 }).notNull(),
	payoutAddress: varchar({ length: 256 }).notNull(),
	payoutAsset: varchar({ length: 255 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	index("IDX__partner_payout_config__partnerId").on(table.partnerId),
	primaryKey({ columns: [table.id], name: "PartnerPayoutConfigs_id"}),
	unique("UQ__partner_payout_config__derivedAddress").on(table.derivedAddress),
	unique("UQ__partner_payout_config__unique_config").on(table.partnerId, table.payoutChain, table.payoutAddress, table.payoutAsset),
]);

export const quoteApprovals = mysqlTable("QuoteApprovals", {
	id: int().autoincrement().notNull(),
	quoteId: int().notNull().references(() => quotes.id, { onDelete: "cascade" } ),
	correlationId: varchar({ length: 64 }).notNull(),
	status: varchar({ length: 16 }).default('PENDING').notNull(),
	amountInUsd: varchar({ length: 32 }).notNull(),
	amountIn: varchar({ length: 64 }).notNull(),
	originAsset: varchar({ length: 255 }).notNull(),
	destinationAsset: varchar({ length: 255 }).notNull(),
	amountOutUsd: varchar({ length: 32 }).notNull(),
	recipient: varchar({ length: 256 }).notNull(),
	refundTo: varchar({ length: 256 }).notNull(),
	accountId: varchar({ length: 64 }).notNull(),
	partnerId: varchar({ length: 64 }),
	reviewedBy: varchar({ length: 256 }),
	reviewedAt: timestamp({ fsp: 3, mode: 'string' }),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	primaryKey({ columns: [table.id], name: "QuoteApprovals_id"}),
	unique("IDX_fa7363ded141e4d87608ec50e0").on(table.quoteId),
]);

export const quoteAssetRewrites = mysqlTable("QuoteAssetRewrites", {
	id: int().autoincrement().notNull(),
	originalOriginAsset: varchar({ length: 255 }),
	originalDestinationAsset: varchar({ length: 255 }),
	quoteId: int().references(() => quotes.id, { onDelete: "cascade" } ),
},
(table) => [
	primaryKey({ columns: [table.id], name: "QuoteAssetRewrites_id"}),
	unique("REL_390c93bc8cf110578d0f8e3338").on(table.quoteId),
]);

export const quoteAuthorities = mysqlTable("QuoteAuthorities", {
	quoteId: int().notNull().references(() => quotes.id, { onDelete: "cascade", onUpdate: "cascade" } ),
	authorityId: int().notNull().references(() => quoteAuthorityAddresses.id),
},
(table) => [
	index("IDX_4947ded027ff7f64080dc8c7a0").on(table.quoteId),
	index("IDX_00ae414529f0c3a264c980dd0d").on(table.authorityId),
	primaryKey({ columns: [table.quoteId, table.authorityId], name: "QuoteAuthorities_quoteId_authorityId"}),
]);

export const quoteAuthorityAddresses = mysqlTable("QuoteAuthorityAddresses", {
	id: int().autoincrement().notNull(),
	address: varchar({ length: 64 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
},
(table) => [
	primaryKey({ columns: [table.id], name: "QuoteAuthorityAddresses_id"}),
	unique("UQ__quote_authority_address__address").on(table.address),
]);

export const quoteEvents = mysqlTable("QuoteEvents", {
	id: int().autoincrement().notNull(),
	depositAddress: varchar({ length: 128 }).notNull(),
	accountId: varchar({ length: 64 }).notNull(),
	status: varchar({ length: 32 }).notNull(),
	event: varchar({ length: 64 }).notNull(),
	timestamp: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	depositMemo: varchar({ length: 64 }),
},
(table) => [
	index("IDX_quote_events_timestamp").on(table.timestamp),
	index("idx_qe_addr_ts").on(table.depositAddress, table.timestamp),
	primaryKey({ columns: [table.id], name: "QuoteEvents_id"}),
]);

export const quoteTransactions = mysqlTable("QuoteTransactions", {
	id: int().autoincrement().notNull(),
	quoteId: int().references(() => quotes.id, { onDelete: "cascade" } ),
	txHash: varchar({ length: 256 }).notNull(),
	transactionType: varchar({ length: 32 }).notNull(),
	sender: varchar({ length: 256 }),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	limitOrderId: int().references(() => limitOrder.id, { onDelete: "cascade" } ),
	partialFillId: int().references(() => partialFill.id, { onDelete: "cascade" } ),
},
(table) => [
	index("IDX__quoteTransactions__txHash").on(table.txHash),
	index("IDX__quoteTransactions__sender").on(table.sender),
	index("IDX__quoteTransactions__createdAt").on(table.createdAt),
	index("IDX__quoteTransactions__partialFillId").on(table.partialFillId),
	index("IDX__quoteTransactions__limitOrderId").on(table.limitOrderId),
	primaryKey({ columns: [table.id], name: "QuoteTransactions_id"}),
	unique("UQ__quoteTransactions__partialFillId_type_hash").on(table.partialFillId, table.transactionType, table.txHash),
	unique("UQ__quoteTransactions__limitOrderId_type_hash").on(table.limitOrderId, table.transactionType, table.txHash),
]);

export const quotes = mysqlTable("Quotes", {
	id: int().autoincrement().notNull(),
	swapType: varchar({ length: 32 }).notNull(),
	slippageTolerance: int().notNull(),
	originAsset: varchar({ length: 255 }).notNull(),
	depositType: varchar({ length: 32 }).notNull(),
	destinationAsset: varchar({ length: 255 }).notNull(),
	amount: varchar({ length: 64 }).notNull(),
	refundTo: varchar({ length: 256 }).notNull(),
	refundType: varchar({ length: 32 }).notNull(),
	recipient: varchar({ length: 256 }).notNull(),
	recipientType: varchar({ length: 32 }).notNull(),
	requestDeadline: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	referral: varchar({ length: 64 }),
	depositAddress: varchar({ length: 128 }).notNull(),
	accountId: varchar({ length: 64 }).notNull(),
	errorMessage: varchar({ length: 64 }),
	amountIn: varchar({ length: 64 }).notNull(),
	amountInFormatted: varchar({ length: 63 }).notNull(),
	amountInUsd: varchar({ length: 32 }).notNull(),
	minAmountIn: varchar({ length: 64 }).notNull(),
	amountOut: varchar({ length: 64 }).notNull(),
	amountOutFormatted: varchar({ length: 63 }).notNull(),
	amountOutUsd: varchar({ length: 32 }).notNull(),
	minAmountOut: varchar({ length: 64 }).notNull(),
	deadline: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	timeWhenInactive: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	timestamp: timestamp({ fsp: 3, mode: 'string' }).default(sql`(CURRENT_TIMESTAMP(3))`).notNull(),
	signature: varchar({ length: 256 }).notNull(),
	status: varchar({ length: 32 }).notNull(),
	intentHashes: text(),
	nearTxHashes: text(),
	originChainTxHashes: text(),
	destinationChainTxHashes: text(),
	actualAmountIn: varchar({ length: 64 }),
	actualAmountInFormatted: varchar({ length: 63 }),
	actualAmountInUsd: varchar({ length: 32 }),
	actualAmountOut: varchar({ length: 64 }),
	actualAmountOutFormatted: varchar({ length: 63 }),
	actualAmountOutUsd: varchar({ length: 32 }),
	actualSlippage: int(),
	refundedAmount: varchar({ length: 64 }).notNull(),
	refundedAmountFormatted: varchar({ length: 63 }).notNull(),
	refundedAmountUsd: varchar({ length: 32 }).notNull(),
	createdAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	updatedAt: datetime({ mode: 'string', fsp: 6 }).default(sql`(CURRENT_TIMESTAMP(6))`).notNull(),
	timeEstimate: int().notNull(),
	quoteWaitingTimeMs: int().notNull(),
	virtualChainRecipient: varchar({ length: 64 }),
	virtualChainRefundRecipient: varchar({ length: 64 }),
	virtualChainProxyTokenRecipient: varchar({ length: 64 }),
	virtualChainProxyTokenRefundRecipient: varchar({ length: 64 }),
	customRecipientMsg: varchar({ length: 1024 }),
	partnerId: varchar({ length: 64 }),
	depositMode: varchar({ length: 32 }).default('SIMPLE').notNull(),
	depositMemo: varchar({ length: 64 }),
	derivationVersion: varchar({ length: 32 }).default('v1').notNull(),
	depositedAmount: varchar({ length: 128 }),
	depositedAmountFormatted: varchar({ length: 128 }),
	depositedAmountUsd: varchar({ length: 128 }),
	refundReason: text(),
	refundFee: varchar({ length: 64 }),
	correlationId: varchar({ length: 64 }),
	authorities: json(),
	withdrawFee: varchar({ length: 64 }),
	passiveWithdrawAddress: varchar({ length: 128 }),
	passiveWithdrawPresetName: varchar({ length: 128 }),
	parentQuoteId: int(),
	confidentiality: varchar({ length: 16 }),
	passiveRefundAddress: varchar({ length: 128 }),
	passiveRefundPresetName: varchar({ length: 128 }),
	executionRoute: varchar({ length: 16 }),
	outboundWithdrawalAccountId: varchar({ length: 64 }),
	outboundRefundAccountId: varchar({ length: 64 }),
},
(table) => [
	index("IDX__quote__deposit_address").on(table.depositAddress),
	index("IDX__quote__status").on(table.status),
	index("IDX__quote__accountId").on(table.accountId),
	index("IDX__quote__createdAt").on(table.createdAt),
	index("IDX__quote__createdAt_depositAddress").on(table.createdAt, table.depositAddress),
	index("IDX__quote__recipient_depositAddress").on(table.recipient, table.depositAddress),
	index("IDX__quote__originAsset").on(table.originAsset),
	index("IDX__quote__destinationAsset").on(table.destinationAsset),
	index("IDX__quote__referral").on(table.referral),
	index("IDX__quote__status_createdAt_depositAddress").on(table.status, table.createdAt, table.depositAddress),
	index("IDX__quote__status_createdAt_referral").on(table.status, table.createdAt, table.referral),
	index("IDX__quote__createdAt_referral").on(table.createdAt, table.referral),
	index("IDX__quote__status_referral_recipient_createdAt").on(table.status, table.referral, table.recipient, table.createdAt),
	index("IDX__quote__depositAddress").on(table.depositAddress),
	index("IDX__quote__recipient").on(table.recipient),
	index("IDX__quote__intentHashes").on(table.intentHashes),
	index("IDX__quote__partnerId_status_createdAt").on(table.partnerId, table.status, table.createdAt, table.depositAddress, table.id),
	index("IDX__quote__parentQuoteId").on(table.parentQuoteId),
	index("IDX__quote__refundTo").on(table.refundTo),
	foreignKey({
			columns: [table.parentQuoteId],
			foreignColumns: [table.id],
			name: "FK_8ece671609ed75fe24d26161dfe"
		}),
	primaryKey({ columns: [table.id], name: "Quotes_id"}),
	unique("IDX_fe6def0328556c06492872d508").on(table.accountId),
	unique("UQ__quote__depositAddress_depositMemo").on(table.depositAddress, table.depositMemo),
]);

export const migrations = mysqlTable("migrations", {
	id: int().autoincrement().notNull(),
	timestamp: bigint({ mode: "number" }).notNull(),
	name: varchar({ length: 255 }).notNull(),
},
(table) => [
	primaryKey({ columns: [table.id], name: "migrations_id"}),
]);
